import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FiUserPlus } from 'react-icons/fi';

export default function Creator({ title, description }) {
    const [creators, setCreators] = useState([]);

    useEffect(() => {
        const fetchCreatorsWithNFTs = async () => {
            try {
                // Получаем все доступные NFT на рынке
                const nftResponse = await axios.get('https://nifty-art.com/api/nfts/market', {
          params: { page: 1, limit: 200 }
        });
                // Правильно обрабатываем новый формат API с пагинацией
                let nfts = [];
                if (nftResponse.data.nfts && Array.isArray(nftResponse.data.nfts)) {
                    nfts = nftResponse.data.nfts;
                } else if (Array.isArray(nftResponse.data)) {
                    nfts = nftResponse.data;
                } else {
                    console.error('Unexpected API response format:', nftResponse.data);
                    nfts = [];
                }

                // Извлекаем уникальных создателей из данных NFT (показываем всех с NFT в продаже)
                const creatorsMap = {};
                nfts.forEach(nft => {
                    if (nft.ownerUsername && !creatorsMap[nft.owner]) {
                        creatorsMap[nft.owner] = {
                            _id: nft.owner,
                            username: nft.ownerUsername,
                            firstName: nft.ownerFirstName || nft.ownerData?.firstName || '',
                            lastName: nft.ownerLastName || nft.ownerData?.lastName || '',
                            avatar: nft.ownerAvatar || '/assets/images/avatar/2.jpg'
                        };
                    }
                });

                const validCreators = Object.values(creatorsMap);
                setCreators(validCreators);
            } catch (error) {
            }
        };

        fetchCreatorsWithNFTs();
    }, []);

    return (
        <div className="container md:mt-24 mt-16">
            <div className="grid grid-cols-1 text-center">
                <h3 className="mb-4 md:text-3xl text-2xl md:leading-snug leading-snug font-semibold">{title}</h3>
                <p className="text-slate-400 max-w-xl mx-auto">{description}</p>
            </div>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-10 gap-[30px]">
                {
                    creators.map((creator, index) => (
                        <div key={index} className="flex justify-between items-center p-3 rounded-md bg-white dark:bg-slate-900 shadow dark:shadow-gray-800">
                            <div className="flex items-center">
                                <div className="relative inline-block">
                                    <img src={creator?.avatar || '/assets/images/avatar/2.jpg'} className="h-16 rounded-md" alt={creator.username} />
                                    <i className="mdi mdi-check-decagram text-emerald-600 text-lg absolute -top-2 -end-2"></i>
                                </div>

                                <div className="ms-3">
                                    <Link to={`/creator-profile/${creator.username}`} className="font-semibold block hover:text-violet-600">
                                        {creator.firstName && creator.lastName ? `${creator.firstName} ${creator.lastName}` : creator.username}
                                    </Link>
                                    <span className="text-slate-400 text-sm block mt-0.5">{creator.username}</span>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

